import React from "react";
import "./style.css";

import facebook from './../../assets/social_icons/facebook.png';
import line from './../../assets/social_icons/line.png';
import viber from './../../assets/social_icons/viber.png';

function ImgDisplay(props)
{
    if (props.type==1)
    {
        return <img src={line} />
    }
    else if (props.type==2)
    {
        return <a href={"viber://chat?number="+props.link} ><img src={viber} /></a>
    }
    else if (props.type==3)
    {
        return <a href={props.link}><img src={facebook} /></a>
    }
}

export default function SocialLink(props) {
  return (
    <div className="social-box">
      {props.custom_design.social_links.map((val) => {
        return (
          <div className="item">
             <ImgDisplay type={val.type} />
             
          </div>
        );
      })}
    </div>
  );
}
